import { SlimPageCard } from "@common/components/layout";
import { ClinicService } from "@common/services";
import { Page } from "@customer/components/layout";
import { RebookStore } from "@customer/stores";
import { observer } from "mobx-react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { usePromiseTracker } from "react-promise-tracker";
import { useParams } from "react-router-dom";

export const RebookContainer = observer(() => {

    const [rebookStore] = useState<RebookStore>(new RebookStore());
    const rebookForm = useRef<HTMLButtonElement | null>(null);
    const { clinicId, reservationPublicId } = useParams();
    const parsedClinicId = useMemo(() => parseInt(clinicId!), [clinicId]);

    const { promiseInProgress } = usePromiseTracker({
        delay: 500,
        area: ClinicService.tags.getReservationForRebooking,
    });

    useEffect(() => {
        if (!_.isUndefined(clinicId) && !_.isUndefined(reservationPublicId)) {
            rebookStore.getReservationForRebooking(parsedClinicId, reservationPublicId).then(() => {
                setTimeout(() => {
                    rebookForm?.current?.click();
                });
            });
        }
    }, [rebookStore, parsedClinicId, reservationPublicId, clinicId]);

    return (
        <Page>
            <Page.Content>
                <SlimPageCard>
                    <Row>
                        <Col md={12}>
                            {(rebookStore.rebookReservation?.reservation && !promiseInProgress) &&
                                <>
                                    <label>If the appointment site doesn&lsquo;t load, click the button below to Re-Book.</label>
                                    <form
                                        action={rebookStore.rebookReservation?.reschedulingSystemUrl}
                                        name="rebook"
                                        id="rebook"
                                        method="POST"
                                        target="_blank">
                                        <input type="text" readOnly hidden={true} name="firstname" value={rebookStore.rebookReservation?.reservation?.firstName} />
                                        <input type="text" readOnly hidden={true} name="lastname" value={rebookStore.rebookReservation?.reservation?.lastName} />
                                        <input type="text" readOnly hidden={true} name="phone" value={rebookStore.rebookReservation?.reservation?.phone1} />
                                        <input type="text" readOnly hidden={true} name="email" value={rebookStore.rebookReservation?.reservation?.emailAddress} />
                                        <input type="text" readOnly hidden={true} name="isreturningcustomer" value={rebookStore.rebookReservation?.reservation?.wasPriorCustomer.toString()} />
                                        <button type="submit" className="btn btn-primary" ref={rebookForm}>
                                            Re-Book Appointment
                                        </button>
                                    </form>
                                </>
                            }
                        </Col>
                        {(!rebookStore.rebookReservation?.reservation && !promiseInProgress) &&
                            <Col md={12}>
                                <h2>We are unable to locate the information you requested.</h2>
                            </Col>
                        }

                        {promiseInProgress &&
                            <Col md={12}>
                                <h2>Locating the information you requested...</h2>
                            </Col>
                        }
                    </Row>
                </SlimPageCard>
            </Page.Content>
        </Page>
    )
})
